import { ProductUserViewEnum } from "@saleor/types/globalTypes";

import { ProductsUser } from "../customTypes/ProductsUser";
import {
  KAMSProductUrlQueryParams,
  ProductUrlQueryParams,
  productVariantEditUrl
} from "../urls";

export default function getProductVariantEditUrlByUserType(
  productUser: ProductsUser,
  productId: string,
  variantId: string,
  params: KAMSProductUrlQueryParams | ProductUrlQueryParams
): string {
  if (productUser.isKAMS && "viewAs" in params) {
    return productVariantEditUrl(productId, variantId, {
      brand: params.brand,
      viewAs: params.viewAs as ProductUserViewEnum,
      ...(productUser.isStoreAdmin && {
        mallId: params.mallId,
        tenant: params.tenant
      })
    });
  }
  return productVariantEditUrl(productId, variantId);
}
